import { render, staticRenderFns } from "./activity-edit.vue?vue&type=template&id=a72c18ca&scoped=true&"
import script from "./activity-edit.vue?vue&type=script&lang=js&"
export * from "./activity-edit.vue?vue&type=script&lang=js&"
import style0 from "./activity-edit.vue?vue&type=style&index=0&id=a72c18ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72c18ca",
  null
  
)

export default component.exports